export default __webpack_public_path__ + "static/media/home-finance-industries-img-03.8a9f2fe7.jpg";